import { render, staticRenderFns } from "./HomeProgramacao.vue?vue&type=template&id=970cb0d4&"
import script from "./HomeProgramacao.vue?vue&type=script&lang=js&"
export * from "./HomeProgramacao.vue?vue&type=script&lang=js&"
import style0 from "./HomeProgramacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports